import { useMemo } from 'react';

import { buildChartSubtitle } from 'helper/Meteorology/Agro/chartSubtitle';
import { WaterBalanceSeries } from 'helper/Meteorology/Agro/waterBalanceSeries';
import useLocations from './useLocations';

// Partes do subtítulo dos gráficos do BH (#2009). O local é o da CONSULTA feita
// (`locationId` = argumento da última requisição), não o selecionado agora no
// painel, e vem da lista de todos os locais, sem depender do grupo selecionado.
export default function useWaterBalanceChartSubtitle({
  series,
  runDate,
  locationId,
}: {
  series: WaterBalanceSeries[] | undefined;
  runDate: string | null;
  locationId: number | undefined;
}): string[] {
  const { locations } = useLocations();
  const locationName = locations?.find((location) => location.id === locationId)?.name;

  return useMemo(
    () => (series ? buildChartSubtitle({ locationName, series, runDate }) : []),
    [locationName, series, runDate],
  );
}
